import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GroupChoice } from '../relationship.models';
import { LaneSite, LaneSitesResponse } from '../../lane-routing-manager/lane.models';
import { RoutingContext, RoutingStopCatalogue, RoutingStopInput, RoutingStopList, RoutingStopRow } from './routing-stop.models';

@Injectable({ providedIn: 'root' })
export class RoutingStopService {
  private readonly endpoint = '/api/managers/routing_stops.php';

  constructor(private readonly http: HttpClient) {}

  private get<T>(action: string, query: Record<string, string> = {}): Observable<T> {
    return this.http.get<T>(this.endpoint, { params: new HttpParams({ fromObject: { action, ...query } }) });
  }

  catalogue(): Observable<RoutingStopCatalogue> {
    return this.get('catalogue');
  }

  list(q: string, customer: string, offset: number): Observable<RoutingStopList> {
    return this.get('list', { q, customer, offset: String(offset) });
  }

  locations(q: string, mode: 'network' | 'all', offset: number): Observable<{ data: LaneSite[]; has_more: boolean }> {
    return this.get('locations', { q, mode, offset: String(offset) });
  }

  groups(customer: string, kind: string, q: string): Observable<{ data: GroupChoice[] }> {
    return this.get('groups', { customer, kind, q });
  }

  options(context: RoutingContext, q = '', offset = 0): Observable<LaneSitesResponse> {
    const query: Record<string, string> = { customer: context.customer, q, offset: String(offset) };
    if (context.pickup) {
      query['pickup_contact'] = context.pickup.contact_uuid;
      query['pickup_address'] = context.pickup.address_uuid;
    }
    if (context.consignee) {
      query['consignee_contact'] = context.consignee.contact_uuid;
      query['consignee_address'] = context.consignee.address_uuid;
    }
    if (context.date) query['date'] = context.date;
    return this.get('options', query);
  }

  save(body: RoutingStopInput, uuid?: string): Observable<{ data: RoutingStopRow }> {
    if (uuid) return this.http.put<{ data: RoutingStopRow }>(this.endpoint, body, { params: { action: 'update', uuid } });
    return this.http.post<{ data: RoutingStopRow }>(this.endpoint, body, { params: { action: 'create' } });
  }
}
